const styles = theme => ({

	root: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		height: '100%',
		minWidth: '0',
		justifyContent: 'flex-start',
		backgroundColor: '#FAFAFA',
		boxShadow: '0px 3px 6px #00000029',
	},

	div: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
	},

	list: {
		width: '100%',
		height: '100%',
		paddingLeft: 21,
		paddingRight: 21,
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
	},

	title: {
		margin: '10px 0 0 10px',
		fontSize: '18px',
	},
});

export default styles;